module.exports = "<ul #container class=\"c-grid-list__wrapper\">\n    <ng-content></ng-content>\n    <li *ngFor='let emptyItem of emptyItemList' class=\"c-grid-list__item\"></li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/grid-list/grid-list.component.html
// module id = ./src/app/modules/common-module/components/grid-list/grid-list.component.html
// module chunks = 9